import { NewSimpleGoalDoc } from "@ailenax-overlay/shared";
import { FC, useMemo } from "react";
import CountUp from "react-countup";
import { defaultFormatters } from "@/lib/utils";
import { getCurrentTitle } from "@/lib/goals";
import "./SimpleDonoGoalWidget.scss";

interface SimpleDonoGoalWidgetProps {
    goal: NewSimpleGoalDoc;
}

export const SimpleDonoGoalWidget: FC<SimpleDonoGoalWidgetProps> = ({ goal }) => {
    const fullTitle = useMemo(() => {
        return getCurrentTitle(goal);
    }, [goal]);

    const realProgress = useMemo(() => {
        if (goal.autoReset) {
            return goal.progress % goal.goal;
        }

        return goal.progress;
    }, [goal.progress, goal.goal, goal.autoReset]);

    return (
        <div className="goal-container">
            <div className="simple-dono-goal">
                <div className="progress-bar" style={{ width: `${100 * Math.min(1, realProgress / goal.goal)}%` }}></div>
                <div className="text">
                    <span className="title">{ fullTitle }</span> <span className="progress"><CountUp decimal="," decimals={2} end={realProgress} duration={0.4} formattingFn={defaultFormatters[goal.kind]} /></span> von <span className="total">{defaultFormatters[goal.kind](goal.goal)}</span>
                </div>
            </div>
        </div>
    );
}